import React, { useEffect, useState } from 'react';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { FlowBuilderActions } from '../../../Services/_actions';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';

interface BotNumberSelectorProps {
    organisation: { organisation_id: string } | null;
    onChange: (value: any) => void;
    value?: any;
    error?: boolean;
    errorMessage?: string;
    disabled?: boolean;
    label: any
    sx?: any
    className?: string;
}

const BotNumberDropdown: React.FC<BotNumberSelectorProps> = ({
    organisation,
    onChange,
    value,
    error = false,
    errorMessage = '',
    disabled = false,
    label = "Select Bot Number",
    sx = {},
    className = "",
}) => {
    const { showSnackBar } = useSnackBar();
    const flowBuilderActions = FlowBuilderActions();
    const [channelList, setChannelList] = useState < any[] > ([]);
    const [loading, setLoading] = useState < boolean > (false);

    useEffect(() => {
        const fetchChannels = async () => {
            if (organisation?.organisation_id) {
                setLoading(true);
                try {
                    const res = await flowBuilderActions.whatsappBusinessAccounts(organisation.organisation_id);
                    if (res?.status === 200) {
                        let data = res?.data?.map((item) => ({
                            ...item,
                            label: `${item?.app_name} (${item?.wa_phone_number})`
                        }));
                        setChannelList(data || []);
                        if (data?.length === 1) {
                            onChange(data[0]);
                        } else if (data?.length === 0) {
                            showSnackBar('No bot number available for this organisation', 'error');
                            onChange(null);
                        }
                    } else {
                        showSnackBar('Unexpected response structure or status.', 'error');
                    }
                } catch (error) {
                    showSnackBar(error?.toString() || 'Failed to fetch bot numbers.', 'error');
                } finally {
                    setLoading(false);
                }
            } else {
                setChannelList([]);
            }
        };

        fetchChannels();
    }, [organisation]);

    return (
        <SearchableDropdown
            label={label}
            options={channelList}
            value={value}
            onChange={onChange}
            // labelKey="app_name"
            valueKey="wa_phone_number"
            error={error}
            errorMessage={errorMessage}
            sx={sx}
            disabled={disabled || channelList?.length === 1}
            loading={loading}
            getOptionLabel={(option) => option?.label ?? option?.app_name}
            className={className || ''}
        />
    );
};

export default BotNumberDropdown;
